import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import SearchInput from '../SearchInput';
import { getSearchFilter } from '../../../../store/files/reducer';
import { onSearchChange } from '../../../../store/files/actions';
import { getNewNotifications} from '../../../../store/notifications/reducer';
import './search-bar.css';

const SearchBar = ({ search, onSearchChange, notifications, history }) => {
	return (
		<div className="search-bar">
			<div className="search-bar__search">
				<SearchInput 
					className="search-bar__input"
					placeholder="Search For A File..."
					search={search} 
					onInputChange={onSearchChange}
					history={history} />
			</div>
			<div className="search-bar__notice">
				<Link to="/notifications" className="search-bar__icon-wrap">
					<span className="search-bar__icon material-icons">chat</span>
					{notifications.length > 0 && <span className="search-bar__notice-bubble">{notifications.length}</span>}
				</Link>
			</div>
		</div>
	);
};

const mapStateToProps = state => {
	return {
		search: getSearchFilter(state.files),
		notifications: getNewNotifications(state.notifications),
	}
}

export default connect(mapStateToProps, { onSearchChange })(SearchBar);


// WEBPACK FOOTER //
// ./src/components/common/search/SearchBar/index.js